import React, { useEffect } from "react";
import { MasterConfigs } from "../../../../interfaces/entity";
import MasterComponent from "../../../../components/Forms";
import { tabsProps } from "../../../../components/Tabs";
import { Button, Space } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import PayGroupSummary from "./PayGroup/Summary";


const PayGroup = () => {
    const location = useLocation();
    const [activeRoute] = React.useState<string>(location.pathname);
    const navigate = useNavigate();

    const config: MasterConfigs = {
        api: () => '/pay-group',
        title: 'Pay Group',
        modalTitle: () => config.title,
        getColumns: () => [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Code',
                dataIndex: 'code',
                key: 'code',
            },
            {
                title: 'Description',
                dataIndex: 'description',
                key: 'description',
                width: '50%',
                ellipsis: true
            },
            {
                title: 'Settings',
                dataIndex: '',
                key: '',
                render: (text, record) => <Button type="link" onClick={() => navigate(`${activeRoute}/details/${record._id}`)}>Settings</Button>
            }
        ],
        getFormColumns: () => [
            {
                label: 'Name',
                name: 'name',
                type: 'text',
                rules: [{ required: true, message: 'Please enter name' }]
            },
            {
                label: 'Code',
                name: 'code',
                type: 'text',
                rules: [{ required: true, message: 'Please enter Code' }]
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                span: 16
            },
        ],
        actions: [{ actionType: 'Add', name: 'Add' }]
    }

    return <>
        <Space direction="vertical" style={{ width: '100%' }}>
            <MasterComponent config={config} />
        </Space>
    </>
}

export default PayGroup;